import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { DialogData, InventoryOrWsreDialogComponent } from '../../inventory/inventory-or-wsre-dialog/inventory-or-wsre-dialog.component';
import { ReportConfigVM } from '../../rope-shovel/models/rope-shovel.model';
import { NotificationsService } from 'angular2-notifications';
import { CustomerSelectItem } from '../../setup-equipment/setup-equipment.model';
import { GenericIdName } from '../../GET_NEW_UI/setup-implement/setup-implement.model';
import { PreferencesService } from '../../preferences/preferences.service';
import { UCComponentInspectionOrderVM } from '../../preferences/models/preferences.model';
import { AppService } from '../../../app.service';
import { ReportConfigurationViewModel, } from '../../GET_NEW_UI/dashboard/dashboard.model';
import { TranslateService } from '../../../../app/translate';
import { Customer, JobSite, SelectionLists } from '../../GET_NEW_UI/entities/global/model';
import moment from 'moment';
import { SharedService } from '../../../../app/shared/services/SharedService';
import { CurrentSelection, Model, SearchItem, UnitNumberModel } from '../../../../app/entities';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { ConfigType } from '../../../../app/shared/enums/allEnums';
@Component({
  selector: 'app-fleet-report-configuration',
  templateUrl: './fleet-report-configuration.component.html',
  styleUrls: ['./fleet-report-configuration.component.scss'],
})
export class FleetReportConfigurationComponent implements OnInit {
  userLanguage = "english";
  customerList: CustomerSelectItem[] = [];
  jobsiteList: GenericIdName[] = [];
  startDate: Date;
  endDate: Date;
  ReportconfigurationList: any[] = [];
  _dropDownLists: SelectionLists = new SelectionLists();
  _dropDownListsFiltered: SelectionLists = new SelectionLists();
  customerModel: { "Id": 225, "Title": "BMA", "DealerId": 1 }
  selectedCustomer: Customer;
  selectedJobsite: JobSite;
  selectedJobsiteForAlert: JobSite[] = [];
  selectedJobsiteFromHeader: JobSite = new JobSite();
  selectedJobsiteId: number;
  isLoading: boolean = false;
  _currentSearchItemSelection: SearchItem[] = [];
  reportConfigurationSubmitModel: ReportConfigurationViewModel[] = []
  _currentSelection: CurrentSelection = new CurrentSelection();
  JobSiteforFleetconfiguration: JobSite = new JobSite()
  selectedFamily: number[] = []
  selectedModel: number[] = []
  selectedUnitNumber: string[] = []
  UCComponentInspectionOrderList: UCComponentInspectionOrderVM[] = [];
  inspectionId: number;
  ReportConfigList: ReportConfigVM[] = [];
  selectedFamilies: any[] = [];
  selectedModels = [];
  selectedUnitNumbers = [];
  ConfigType = ConfigType;
  customerId: number = 0;
  JobSiteId: number = 0;
  JobSiteIds: number[] = [];
  unitData: UnitNumberModel[];
  unitDataFiltered: UnitNumberModel[];
  RequestFromFlag: string; // "Fleet_Report" for fleet report, "Alert_Report" for report alert
  isModalLoader: boolean;
  public modelList: Model[] = [];
  public filteredModel: Model[] = [];
  Alertid: number;
  filterMakeModelFamilyForExistingOnly = true;
  @ViewChild('familychipInput') familychipInput: ElementRef<HTMLInputElement>;
  @ViewChild('modelInput') modelInput: ElementRef<HTMLInputElement>;
  @ViewChild('unitInput') unitInput: ElementRef<HTMLInputElement>;
  get defaultSearchStartDate(): Date {
    const date = new Date(Date.now());
    date.setMonth(date.getMonth() - 3);
    return date;
  }
  get defaultSearchEndDate(): Date {
    const date = new Date();
    date.setDate(date.getDate() + 1);
    return date;
  }
  constructor(public _dialogRef: MatDialogRef<InventoryOrWsreDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,

    private _appService: AppService,
    private _translate: TranslateService,
    private _notification: NotificationsService,
    private _sharedService: SharedService,
    private readonly _pref: PreferencesService,) { }

  ngOnInit() {
    this.RequestFromFlag = this.data.RequestFromFlag;
    this.Alertid = this.data.alertId;
    if (this.RequestFromFlag === undefined) {
      this.RequestFromFlag = this.ConfigType.Fleet; // default to fleet report if not provided
    }
    this._currentSelection = this._appService.getLastSelection();
    this.loadCustomers();
    this._sharedService.sharedData$
      .subscribe(sharedData => this.selectedJobsiteFromHeader = sharedData);
    this._sharedService.getCustomerInfo().subscribe(info => {
      this.JobSiteforFleetconfiguration = info;
    })
      this.loadAllFamilyList()
      this.LoadModal()

    if (this.RequestFromFlag === this.ConfigType.Alert) {
       this.getAlertReportConfiguration();
      
    } 
  }

  loadCustomers() {
    this._appService.getCustomerListForSelection(1, 10000).subscribe(
      result => {
        this._dropDownLists.customerList = result;
        this._dropDownListsFiltered.customerList = result;
        this.loadJobsitesForCustomer();
      },
      error => {
        console.error(error);
      },
      () => {
      }
    );
  }

  selectFamily(event: any): void {
    const familyName = event.option.value;
    const selectedFamily = this._dropDownLists.familyList.find(f => f.Title === familyName);
    if (selectedFamily && !this.selectedFamilies.some(f => f.Title === selectedFamily.Title)) {
      this.selectedFamilies.push(selectedFamily);
      this.selectedFamily.push(selectedFamily.Id);
    }
    this.familychipInput.nativeElement.value = '';
    this.selectedFamilies = [...new Set(this.selectedFamilies)];

    this._dropDownListsFiltered.modelList =
      this._dropDownLists.modelList.filter(x =>
        this.selectedFamilies.some(f => f.Id === x.FamilyId)
      );
    this.filterFamilies('');
    if(this.RequestFromFlag==this.ConfigType.Fleet){
      this.submitFleetReport(this.reportConfigurationSubmitModel, false);
       this.LoadUnitNumber();
    }
  else
    this.submitFleetAlertReport(this.reportConfigurationSubmitModel, false);
    
  }


  addFamily(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    // Add the family name if valid and not already selected
    const foundFamily = this._dropDownLists.familyList.find(family => family.Title.toLowerCase() === value.toLowerCase());
    if (foundFamily && !this.selectedFamilies.includes(foundFamily.Title)) {
      this.selectedFamilies.push(foundFamily.Title); // Store the Name for display
    }
    // Clear the input value
    event.chipInput!.clear();
    this.filterFamilies('');
  }
  // Filter families based on user input
  filterFamilies(value: string): void {
    const filterValue = value.toLowerCase();
    this._dropDownListsFiltered.familyList = this._dropDownLists.familyList.filter(family =>
      family.Title.toLowerCase().includes(filterValue) && !this.selectedFamilies.includes(family.Title)
    );
    // Reset filtered families if input is empty
    if (value === '') {
      this._dropDownListsFiltered.familyList = [...this._dropDownLists.familyList];
    }
  }

  // Remove a family from the chip list
  removeFamily(familyName: string): void {
    const index = this.selectedFamilies.indexOf(familyName);
    if (index >= 0) {
      this.selectedFamilies.splice(index, 1);
      this.selectedFamily.splice(index, 1);
      this.filterFamilies('');
    }
    this.submitFleetReport(this.reportConfigurationSubmitModel, false);
    this.LoadUnitNumber();
  }

  // Remove model from selected list
  removeModel(model: any): void {
    const index = this.selectedModels.indexOf(model);
    if (index >= 0) {
      this.selectedModel.splice(index, 1);
      this.selectedModels.splice(index, 1);
    }
    this.submitFleetReport(this.reportConfigurationSubmitModel, false);
    this.LoadUnitNumber();
  }

  addModel(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    const foundModel = this._dropDownLists.modelList.find(model => model.Title.toLowerCase() === value.toLowerCase());
    if (foundModel && !this.selectedModels.includes(foundModel)) {
      this.selectedModels.push({ Name: value });
    }
    event.chipInput!.clear();
    this.filterModels('');
  }

  filterModels(value: string): void {
    const filterValue = value.toLowerCase();
    this._dropDownListsFiltered.modelList = this._dropDownLists.modelList.filter(model => model.Title.toLowerCase().includes(filterValue))
  }

  selectModel(event: MatAutocompleteSelectedEvent): void {
    const model = event.option.value;
    const Id = event.option.value.Id;
    this.selectedModel.push(Id);
    const selectedModel = this._dropDownLists.modelList.find(f => f.Title === model.Title);

    if (selectedModel && !this.selectedModels.some(f => f.Title === selectedModel.Title)) {
      this.selectedModels.push(selectedModel);
      this.selectedModel.push(selectedModel.Id);
    }

    // if (!this.selectedModels.some(selectedModel => selectedModel.Name === model.Name)) {
    //   this.selectedModels.push(model);
    // }
    if (this.modelInput.nativeElement != undefined) {
      this.modelInput.nativeElement.value = '';

    }
    //this.modelInput.nativeElement.value = '';
    this.filterModels('');
    this._dropDownListsFiltered.modelList =
      this._dropDownLists.modelList.filter(x =>
        this.selectedFamilies.some(f => f.Id === x.FamilyId)
      );
    if(this.RequestFromFlag==this.ConfigType.Fleet){
      this.submitFleetReport(this.reportConfigurationSubmitModel, false);
       this.LoadUnitNumber();
    }
  else
    this.submitFleetAlertReport(this.reportConfigurationSubmitModel, false);
  }

  loadJobsitesForCustomer() {
    this._appService.getJobSiteListForSelection(1, 10000).subscribe(
      result => {
        this._dropDownLists.jobSiteList = result;
        this._dropDownListsFiltered.jobSiteList = result;
        if (this.RequestFromFlag == this.ConfigType.Alert) {
          this.getAlertReportConfiguration();
        } else {
          this.getFleetReportConfiguration();
        }
      },
      error => {
        console.error(error);
      },
      () => {
      }
    );
  }

  filteredFamilies: GenericIdName[] = [];
  loadAllFamilyList() {
    this._appService.getFamilyListForSelection(1, 10000).subscribe(result => {
      this._dropDownLists.familyList = this._dropDownListsFiltered.familyList = result.filter(x => x.ExistingCount > 0);
    }, error => { console.error(error); }, () => { });
  }


  LoadModal() {
    this.isModalLoader = true;
    this._appService.getModelListForSelection(1, 10000).subscribe(result => {
      console.log(result);
      this._dropDownLists.modelList = result.filter(m => m).filter(m => m.ExistingCount > 0);
      this._dropDownListsFiltered.modelList = result.filter(m => m).filter(m => m.ExistingCount > 0);
      this.isModalLoader = false;
     if (this.RequestFromFlag === this.ConfigType.Fleet) 
      this.getFleetReportConfiguration();
    else    
    this.getAlertReportConfiguration();
    }, error => { console.error(error); }, () => { }
    );
  }
  slecetdFamily: string;
  getFleetReportConfiguration() {

    this._appService.getFleetReportConfiguration().subscribe(r => {
      if (r) {
        this.reportConfigurationSubmitModel = r;
        if (this.reportConfigurationSubmitModel.length == 0) {
          const d = new Date();
          this.reportConfigurationSubmitModel.forEach(e => {
            e.StartDate = new Date(d.setMonth(d.getMonth() - 1));
            e.EndDate = new Date();
          });
        }
        else {
          const selectedFamily = this.reportConfigurationSubmitModel[0].FamilyId;
          this.populateSelectedFamilies(selectedFamily.toString());
          const selectedModel = this.reportConfigurationSubmitModel[0].ModelId;
          this.populateSelectedModel(selectedModel.toString());
          this._dropDownListsFiltered.modelList =
            this._dropDownLists.modelList.filter(x =>
              this.selectedFamilies.some(f => f.Id === x.FamilyId)
            );

          this.JobSiteforFleetconfiguration.CustomerId = this.reportConfigurationSubmitModel[0].CustomerId;
          // if (ConfigType.Alert == this.RequestFromFlag) {
            this.selectedJobsiteId = this.JobSiteforFleetconfiguration.Id;
          // } else {
          //   this.JobSiteforFleetconfiguration.Id = this.reportConfigurationSubmitModel[0].JobsiteId;
          // }

          
          const d = new Date();
          this.reportConfigurationSubmitModel.forEach(e => {
            e.StartDate = new Date(d.setMonth(d.getMonth() - 1));
            e.EndDate = new Date();
            e.Customer = this._dropDownLists.customerList.filter(
              m => m.Id === this.JobSiteforFleetconfiguration.CustomerId
            )[0].Title;
            this._dropDownListsFiltered.jobSiteList = this._dropDownLists.jobSiteList.filter(
              m => m.CustomerId === this.JobSiteforFleetconfiguration.CustomerId
            );
            this.customerId = this.JobSiteforFleetconfiguration.CustomerId;
            this.JobSiteId = this.JobSiteforFleetconfiguration.Id;
            e.Jobsite = this._dropDownLists.jobSiteList.filter(
              m => m.Id === this.JobSiteforFleetconfiguration.Id)[0];
               e.JobsiteIds = this.reportConfigurationSubmitModel[0].JobsiteIds;
           let jobsiteIds = this.selectedJobsiteIds.join(',');
            this.selectedJobsiteIds = this.reportConfigurationSubmitModel[0].JobsiteIds.split(',').map((x: string) => Number(x));
          });
          this.LoadUnitNumber();
        }
      }
    });
  }

  populateSelectedFamilies(selectedFamily: string) {
    // clear old values
    this.selectedFamilies = [];

    if (!selectedFamily) return;

    // split ids and convert to number
    const familyIds = selectedFamily.split(',').map((id: string) => +id.trim());

    // match ids from familyList
    familyIds.forEach(id => {
      const family = this._dropDownLists.familyList.find((f: any) => f.Id === id);
      if (family) {
        this.selectedFamilies.push({
          Id: family.Id,
          Title: family.Title
        });
      }
    });
  }

  populateSelectedUnitNumbers(selectedUnitNumber: string) {
    // clear old values
    this.selectedUnitNumbers = [];
    if (!selectedUnitNumber) return;
    // split ids and convert to number
    const unitNumberIds = selectedUnitNumber.split(',').map((id: string) => id.trim());
    // match ids from familyList
    unitNumberIds.forEach(id => {
      const family = this.unitData.find((f: any) => f.UnitNumber === id);
      if (family) {
        this.selectedUnitNumbers.push({
          EquipmentId: family.EquipmentId,
          UnitNumber: family.UnitNumber
        });
      }
    });
  }

  populateSelectedModel(selectedFamily: string) {
    // clear old values
    this.selectedModels = [];
    if (!selectedFamily) return;
    // split ids and convert to number
    const modelIds = selectedFamily.split(',').map((id: string) => +id.trim());
    // match ids from familyList
    modelIds.forEach(id => {
      const family = this._dropDownLists.modelList.find((f: any) => f.Id === id);
      if (family) {
        this.selectedModels.push({
          Id: family.Id,
          Title: family.Title
        });
      }
    });
  }


  CheckBoxselect(i: any, value: number) {
    i.IsReportChek = value == 1 ? false : true;
    if(this.RequestFromFlag==this.ConfigType.Alert){
    this.submitFleetAlertReport(this.reportConfigurationSubmitModel, false);

    }else{
    this.submitFleetReport(this.reportConfigurationSubmitModel, false);
    }
  }

  Translate(value: string): string {
    return this._translate.translateToLang(value, this.userLanguage);
  }
  customerChanged(event: any) {
    if (event.target.value != "") {
      const filterValue = event.target.value.toLowerCase();
      this._dropDownListsFiltered.customerList = this._dropDownLists.customerList.filter(option => option.Title.toLowerCase().includes(filterValue));
    }
  }

  onSelectCustomer(event: any) {
    let id = this._dropDownListsFiltered.customerList.find(f => f.Title == event.value).Id
    this.selectedCustomer = event.value;
    this.reportConfigurationSubmitModel.forEach(e => {
      e.CustomerId = id;
    });
    this.customerId = id;
    this._dropDownListsFiltered.jobSiteList = null;
    this._dropDownListsFiltered.jobSiteList = this._dropDownLists.jobSiteList.filter(
      m => m.CustomerId === id
    );
    this.submitFleetReport(this.reportConfigurationSubmitModel, false);
  }

  jobsiteChanged(event: any): void {
    debugger;
    this.selectedJobsite = event.value;
    if (!this.selectedJobsite) {
      return;
    }
    this.reportConfigurationSubmitModel.forEach(e => {
      e.JobsiteId = this.selectedJobsite.Id;
    });
    this.JobSiteId = this.selectedJobsite.Id;
    this.submitFleetReport(this.reportConfigurationSubmitModel, false);
    this.LoadUnitNumber();
  }

  jobsiteChangedAlerts(event: any) {
  this.selectedJobsiteIds = event.value;
  if(this.ConfigType.Alert == this.RequestFromFlag)
this.submitFleetAlertReport(this.reportConfigurationSubmitModel, false);
  else
    this.submitFleetReport(this.reportConfigurationSubmitModel, false);
}

  dateChanged(event, id: number) {
    let date = new Date(event);
    if (id == 1) {
      this.reportConfigurationSubmitModel.forEach(e => {
        e.StartDate = date;
      });
    }
    else {
      this.reportConfigurationSubmitModel.forEach(e => {
        e.EndDate = date;
      });
    }
    this.submitFleetReport(this.reportConfigurationSubmitModel, false);
  }

  onCloseClick(): void {
    this._dialogRef.close(false);
  }

  recalculateSortOrder(item: any, index: number, incrementOrder: number) {
    if (this.customerId == 0 && this.JobSiteId == 0) {
      this._notification.warn('Please select customer and jobsite then try again!');
      return;
    }
    if (incrementOrder == 1) {
      let oldItem = this.reportConfigurationSubmitModel[index - 1];
      oldItem.SortOrder = item.SortOrder;
      item.SortOrder = item.SortOrder - 1;
      this.reportConfigurationSubmitModel[index - 1] = item;
      this.reportConfigurationSubmitModel[index] = oldItem;
    }
    else {
      // this.reportConfigurationSubmitModel[index-1].SortOrder = sortOrder-1;
      let oldItem = this.reportConfigurationSubmitModel[index + 1];
      oldItem.SortOrder = item.SortOrder;
      item.SortOrder = item.SortOrder + 1;
      this.reportConfigurationSubmitModel[index + 1] = item;
      this.reportConfigurationSubmitModel[index] = oldItem;
    }
    this.submitFleetReport(this.reportConfigurationSubmitModel, true);
  }

  submitFleetReport(reportConfigurationSubmitModel: ReportConfigurationViewModel[], isRefresh: boolean = false) {
    if ((this.customerId == 0 || this.JobSiteId == 0) && this.reportConfigurationSubmitModel[0].IsReset == false) {
      return;
    }
    reportConfigurationSubmitModel.forEach((e: any) => {
      e.StartDateString = moment(this.reportConfigurationSubmitModel[0].StartDate).format('MM/DD/YYYY');
      e.EndDateString = moment(this.reportConfigurationSubmitModel[0].EndDate).format('MM/DD/YYYY');
      e.CustomerId = this.reportConfigurationSubmitModel[0].CustomerId;
      // e.JobsiteId = this.reportConfigurationSubmitModel[0].JobsiteId;
       e.JobsiteIds = this.selectedJobsiteIds.join(',');
      e.FamilyId = this.selectedFamilies.map(f => f.Id).join(',');
      e.ModelId = this.selectedModels.map(f => f.Id).join(',');
      e.UnitNumber = this.selectedUnitNumbers.map(f => f.UnitNumber).join(',')
    });
    console.log("this.reportConfigurationSubmitModel submit:", this.reportConfigurationSubmitModel);
    this._appService.submitFleetReport(reportConfigurationSubmitModel).subscribe(result => {
      if (result) {
        if (isRefresh)
          this.getFleetReportConfiguration();
        else
          this.LoadUnitNumber();
      }
      else {
        this.LoadUnitNumber();
      }
      this.isLoading = false;
    });
  }

  FleetReportPdf() {
    let data = {}
    if (this.customerId == 0 || this.JobSiteId == 0) {
      this._notification.warn('Please select customer and jobsite and try again!');
      return
    }
    this._pref.FleetReportPdf(data).subscribe(r => {
      if (r.m_Item1) {
      }
    }, error => {
      console.error(error);
    });
  }

  printPDF() {
    if (this.customerId == 0 || this.JobSiteId == 0) {
      this._notification.warn('Please select customer and jobsite and try again!');
      return
    }
    this.submitFleetReport(this.reportConfigurationSubmitModel, false);
    window.open(this._appService.getBaseURL() + '/api/Dashboard/GetFleetReportPdf?cu=' + this.customerId + "&jb=" +1 + "&sDate=" + moment(this.reportConfigurationSubmitModel[0].StartDate).format('MM/DD/YYYY') + "&eDate=" + moment(this.reportConfigurationSubmitModel[0].EndDate).format('MM/DD/YYYY'), '_blank');
  }

  selectUnitNumber(event: MatAutocompleteSelectedEvent): void {
    const model = event.option.value;
    const Id = event.option.value.Id;
    this.selectedUnitNumber.push(Id);
    const selectedModel = this.unitData.find(f => f.UnitNumber === model.UnitNumber);
    if (selectedModel && !this.selectedUnitNumbers.some(f => f.UnitNumber === selectedModel.UnitNumber)) {
      this.selectedUnitNumbers.push(selectedModel);
      this.selectedUnitNumber.push(selectedModel.UnitNumber);
    }
    if (this.unitInput.nativeElement != undefined) {
      this.unitInput.nativeElement.value = '';
    }
    //this.modelInput.nativeElement.value = '';
    this.filterUnitNumbers('');
    this.submitFleetReport(this.reportConfigurationSubmitModel, false);
  }

  removeUnitNumber(model: any): void {
    const index = this.selectedUnitNumbers.indexOf(model);
    if (index >= 0) {
      this.selectedUnitNumber.splice(index, 1);
      this.selectedUnitNumbers.splice(index, 1);
    }
    this.submitFleetReport(this.reportConfigurationSubmitModel, false);
  }

  filterUnitNumbers(value: string): void {
    const filterValue = value.toLowerCase();
    this.unitDataFiltered = this.unitData.filter(model => model.UnitNumber.toLowerCase().includes(filterValue))
  }

  LoadUnitNumber() {
    this._appService.getUnitNumberByCustomerFamily(this.customerId, this.selectedJobsiteIds.join(',')).subscribe(
      result => {
        this.unitData = result.Data;
        this.unitDataFiltered = result.Data;
        const selectedUnitNumber = this.reportConfigurationSubmitModel[0].UnitNumber;
        this.populateSelectedUnitNumbers(selectedUnitNumber.toString());
      },
      error => {
        console.error(error);
      },
      () => {
      }
    );
  }

  reset() {
    this.reportConfigurationSubmitModel[0].CustomerId = null;
    this.reportConfigurationSubmitModel[0].JobsiteId = null;
    this.reportConfigurationSubmitModel.forEach(e => { e.IsReset = true; });
    this.selectedFamilies = [];
    this.selectedModels = [];
    this.selectedUnitNumbers = [];
    this.customerId = 0;
    this.JobSiteId = 0;
    this.submitFleetReport(this.reportConfigurationSubmitModel);
    this._currentSelection = this._appService.getLastSelection();
    this.loadCustomers();
    this._sharedService.sharedData$
      .subscribe(sharedData => this.selectedJobsiteFromHeader = sharedData);
    this._sharedService.getCustomerInfo().subscribe(info => {
      this.JobSiteforFleetconfiguration = info;
    })
    this.loadAllFamilyList()
    this.LoadModal();
  }

  submitFleetAlertReport(reportConfigurationSubmitModel: ReportConfigurationViewModel[], isRefresh: boolean = false) {
    if ((this.customerId == 0 || this.selectedJobsiteIds.length == 0) && this.reportConfigurationSubmitModel[0].IsReset == false) {
      return;
    }
    reportConfigurationSubmitModel.forEach((e: any) => {
      e.StartDateString = moment(this.reportConfigurationSubmitModel[0].StartDate).format('MM/DD/YYYY');
      e.EndDateString = moment(this.reportConfigurationSubmitModel[0].EndDate).format('MM/DD/YYYY');
      e.CustomerId = this.reportConfigurationSubmitModel[0].CustomerId;
       e.FamilyId = this.selectedFamilies.map(f => f.Id).join(',');
      e.ModelId = this.selectedModels.map(f => f.Id).join(',');
       e.JobsiteIds = this.selectedJobsiteIds.join(',');
       e.AlertId = this.Alertid; 
    });
    this._pref.submitFleetAlertReport(reportConfigurationSubmitModel).subscribe(result => {
      if (result) {
        if (isRefresh)
          this.getAlertReportConfiguration();
      }
      else {
      }
      this.isLoading = false;
    });
  }

  getAlertReportConfiguration() {
    this._pref.getAlertFleetReportConfiguration().subscribe(r => {
      if (r) {
        this.reportConfigurationSubmitModel = r;
        if (this.reportConfigurationSubmitModel.length == 0) {
          const d = new Date();
          this.reportConfigurationSubmitModel.forEach(e => {
            e.StartDate = new Date(d.setMonth(d.getMonth() - 1));
            e.EndDate = new Date();
          });
        }
        else {
            const selectedFamily = this.reportConfigurationSubmitModel[0].FamilyId;
            if(selectedFamily!=null)
          this.populateSelectedFamilies(selectedFamily.toString());
         
           
            const selectedModel = this.reportConfigurationSubmitModel[0].ModelId;
             if(selectedModel!=null)
          this.populateSelectedModel(selectedModel.toString());

          this._dropDownListsFiltered.modelList =
            this._dropDownLists.modelList.filter(x =>
              this.selectedFamilies.some(f => f.Id === x.FamilyId)
            );
          this.JobSiteforFleetconfiguration.CustomerId = this.reportConfigurationSubmitModel[0].CustomerId;
         
          if(this.JobSiteforFleetconfiguration.CustomerId>0){

         
          
          //   this.JobSiteforFleetconfiguration.Id = this.reportConfigurationSubmitModel[0].JobsiteId;
        
          // this.selectedJobsiteId = this.JobSiteforFleetconfiguration.Id;
          const d = new Date();
          this.reportConfigurationSubmitModel.forEach(e => {
            e.StartDate = new Date(d.setMonth(d.getMonth() - 1));
            e.EndDate = new Date();

            e.Customer = this._dropDownLists.customerList.length>0 ? this._dropDownLists.customerList.filter(
              m => m.Id === this.JobSiteforFleetconfiguration.CustomerId
            )[0].Title : '';

            this._dropDownListsFiltered.jobSiteList = this._dropDownLists.jobSiteList.filter(
              m => m.CustomerId === this.JobSiteforFleetconfiguration.CustomerId
            );
             this.customerId = this.JobSiteforFleetconfiguration.CustomerId;
            //  this.JobSiteId = this.JobSiteforFleetconfiguration.Id;
           e.JobsiteIds = this.reportConfigurationSubmitModel[0].JobsiteIds;
           let jobsiteIds = this.selectedJobsiteIds.join(',');


           this.selectedJobsiteIds = this.reportConfigurationSubmitModel[0].JobsiteIds.split(',').map((x: string) => Number(x));
          });
        }
         }
      }
    });
  }
  selectedJobsiteIds: number[] = [];
}
